import { render, staticRenderFns } from "./editStudent.vue?vue&type=template&id=f9a9cd6a"
import script from "./editStudent.vue?vue&type=script&lang=js"
export * from "./editStudent.vue?vue&type=script&lang=js"
import style0 from "./editStudent.vue?vue&type=style&index=0&id=f9a9cd6a&prod&lang=less"
import style1 from "./editStudent.vue?vue&type=style&index=1&id=f9a9cd6a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports